import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import CheckboxDropdownComponent from './CheckboxDropdownComponent';
import { CheckboxDropdownContext } from '../../context';
import styles from '@dtsl/css-checkbox-dropdown/dist/index.module.css';
function CheckboxDropdownBody(props) {
  const {
    isOpen
  } = useContext(CheckboxDropdownContext);
  const {
    menuPlacement,
    menuClassName = ''
  } = props;
  const menuClass = classNames({
    [styles['sib-checkbox-dropdown-menu']]: true,
    [styles['placement-top']]: menuPlacement === 'top',
    [menuClassName]: !!menuClassName
  });
  return isOpen ? /*#__PURE__*/React.createElement("div", {
    className: menuClass,
    "aria-expanded": "true"
  }, /*#__PURE__*/React.createElement(CheckboxDropdownComponent, props)) : null;
}
CheckboxDropdownBody.propTypes = {
  menuClassName: PropTypes.string,
  menuPlacement: PropTypes.string.isRequired
};
export default CheckboxDropdownBody;